<template>
  <v-col cols="12" md="4" class="py-0">
    <v-row>
      <v-col cols="12" class="py-0">
        <h3>{{ parseInt(vkey) + 1 }}. kezelő</h3>
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <v-text-field v-model="kezelo.tipus" label="Típus"
      /></v-col>
      <v-col cols="12" md="6" class="py-0">
        <v-text-field v-model="kezelo.gyarto" label="Gyártó"
      /></v-col>
      <v-col cols="12" class="py-0">
        <v-text-field v-model="kezelo.sorozatszam" label="Sorozatszám" />
      </v-col>
      <v-col cols="12">
        <v-btn
          color="error"
          :block="true"
          text
          @click="removeKezeloRiaszto(vkey)"
          >Törlés</v-btn
        >
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  props: ["kezelo", "vkey", "removeKezeloRiaszto"]
};
</script>
